var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"remark-item-content-right comment-image"},[_c('RemarkImage',{attrs:{"item":_vm.item}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }